module.exports = __webpack_public_path__ + "img/node_icon.b3fc8589.svg";